import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Conceptos } from '@p-p-portafolio/interfaces/conceptos';
import { EntityOperationResult } from '@shared/interfaces/responses/entity-operation-result';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConceptosService {
  private baseUrl = environment.apiBaseUrl + 'api/conceptos';
  private newBackBaseUrl = environment.apiNewBackBaseUrl;
  private user = localStorage.getItem('user')
    ? localStorage.getItem('user')
    : 'Invitado';

  constructor(private http: HttpClient) {}

  form: UntypedFormGroup = new UntypedFormGroup({
    concepto: new UntypedFormControl(null, [Validators.required]),
    descripcion: new UntypedFormControl('', [Validators.maxLength(40)]),
    aplicaPagoMinimo: new UntypedFormControl(null),
    aplicaSaldoPromedio: new UntypedFormControl(null),
    integraConsumo: new UntypedFormControl(null),
  });

  initializeFormGroup() {
    this.form.setValue({
      concepto: null,
      descripcion: '',
      aplicaPagoMinimo: null,
      aplicaSaldoPromedio: null,
      integraConsumo: null,
    });
  }

  populateForm(entity: Conceptos) {
    this.form.setValue(entity);
  }

  getAll() {
    const url = `${this.baseUrl}`;
    return this.http.get<Conceptos[]>(url);
  }

  getConceptosList() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    const payload = {
      que: 4,
      tope: "9999",
      numero: 0,
      descripcion: "",
      aplicaSaldoMinimo: 0,
      aplicaSaldoPromedio: 0,
      integraConsumo: 0
    };

    const url = `${this.newBackBaseUrl}Conceptos/caspa_ConceptosList`;
    return this.http.post<any>(
      url,
      payload,
      httpOptions
    );
  }

  getById(id: string) {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get<Conceptos>(url);
  }

  add(entity: Conceptos) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    const url = `${this.baseUrl}/add`;
    return this.http.post<EntityOperationResult>(
      url + '/' + this.user,
      entity,
      httpOptions
    );
  }

  saveConcepto(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    const url = `${this.newBackBaseUrl}Conceptos/caspa_ConceptosAdd`;
    return this.http.post<EntityOperationResult>(
      url,
      payload,
      httpOptions
    );
  }

  updateConcepto(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    const url = `${this.newBackBaseUrl}Conceptos/caspa_ConceptosUpd`;
    return this.http.post<EntityOperationResult>(
      url,
      payload,
      httpOptions
    );
  }

  update(entity: Conceptos) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    const url = `${this.baseUrl}/upd`;
    return this.http.put<EntityOperationResult>(
      url + '/' + this.user,
      entity,
      httpOptions
    );
  }

  delete(entity: Conceptos) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    const payload = {
      que: 3,
      tope: "",
      numero: entity.concepto,
      descripcion: "",
      aplicaSaldoMinimo: 0,
      aplicaSaldoPromedio: 0,
      integraConsumo: 0
    };

    const url = `${this.newBackBaseUrl}Conceptos/caspa_ConceptosDelete`;
    return this.http.post<any>(
      url,
      payload,
      httpOptions
    );
  }
}
